export enum SearchBarSkipKeys {
    modificationDate = 'modificationDate',
    contentType = 'contentType',
    active='active',
    isWarning ='isWarning',
    showInHeader ='showInHeader',
    top = 'top',
    left = 'left',
    scale = 'scale',
    angle = 'angle',
    flip = 'flip',
    author = 'author',
    authorId = 'authorId',
    initials = 'initials',
    professionId = 'professionId',
    deprecated = 'deprecated',
    private = 'private',
    id = 'id',
    fieldId = 'fieldId',
    templateFieldId = 'templateFieldId',
    templateId = 'templateId',
    entryTypeId = 'entryTypeId',
    fieldType = "fieldType",
    fieldTypeId = "fieldTypeId",
    schemaId ='schemaId',
    symbolId ='symbolId',
    placedSymbolId ='placedSymbolId',
    dorsalisPedisLeft ='dorsalisPedisLeft',
    dorsalisPedisRight ='dorsalisPedisRight',
    posteriorTibialLeft ='posteriorTibialLeft',
    posteriorTibialRight ='posteriorTibialRight',
    diagnosisId ='diagnosisId'
}